<template>
  <div>
    <el-container>
      <el-main class="login-main">
        <div class="loginHead">
          <img src="../../assets/loginLogo.png" class="loginHead-img">
          <span class="loginHead-title">润泽园区企业系统</span>
        </div>
        <el-form class="form" label-position="right" label-width="80px" :model="form">
          <el-form-item>
            <el-input placeholder="请输入手机号" v-model="form.phone" type="phone"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入验证码" v-model="form.vCode">
              <template slot="append">
                <el-button
                  type="text"
                  :disabled="form.phone == ''||btnTime>0"
                  class="get-code"
                  @click="getCode"
                >{{btnTime>0?btnTime+'s':'获取验证码'}}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              class="login-btn"
              type="success"
              @click="login"
              :disabled="(form.phone == '')||(form.vCode == '')"
            >登录</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { loginCode, login, getCompany } from '@/api/login'
import { regPhone } from '@/utils'
import axios from 'axios'
export default {
  name: '',
  data () {
    return {
      form: {
        phone: '',
        vCode: ''
      },
      btnTime: 0
    }
  },
  mounted () {
    // this.clear();
    if (localStorage.token) {
      this.getCompanyList()
    }
  },
  methods: {
    getCode () {
      if (this.btnTime > 0) return
      let that = this
      if (regPhone(this.form.phone)) {
        loginCode(this.form.phone, 1)
          .then(res => {
            if (res === '') {
              this.$message({
                type: 'success',
                message: `发送成功`
              })
              that.btnTime = 60
              let codeClock = window.setInterval(() => {
                that.btnTime--
                if (that.btnTime < 1) {
                  // 0就不用显示了
                  window.clearInterval(codeClock)
                }
              }, 1000)
            } else {
              this.$message(res.msg)
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              type: 'warn',
              message: `发送失败`
            })
          })
      } else {
        this.$message({
          type: 'warn',
          message: `请输入正确的手机号`
        })
      }
    },
    getCompanyList () {
      getCompany()
        .then(res => {
          localStorage.company = JSON.stringify(res.companys[0]) // 保存第一个公司的信息到本地 为了刷新页面的时候 还能正常的显示之前的公司
          localStorage.companyId = res.companys[0].companyId
          localStorage.auth = res.companys[0].identity
          localStorage.userInfo = JSON.stringify(res)
          this.$router.replace('/welfarelist')
        })
        .catch(err => {
          console.log(err)
        })
    },
    login () {
      login(this.form.phone, this.form.vCode, '1', '1', '1', '1')
        .then(res => {
          localStorage.token = res
          this.getCompanyList()
        })
        .catch(err => {
          console.log(err)
        })
    },
    clear () {
      localStorage.clear()
    }
  }
}
</script>

<style lang="scss" scoped>
.get-code {
  cursor: pointer;
  width: 90px;
  color: primary;
}
.login-main {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url("../../assets/loginBg.jpg");
  background-size: 100% 100%;
  > .loginHead {
    margin-bottom: 130px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    > .loginHead-img {
      width: 60px;
      height: 60px;
      margin-right: 8px;
    }
    .loginHead-title {
      font-size: 36px;
      font-weight: bold;
      color: #fff;
    }
  }
  .form {
    width: 400px;
    height: 300px;
    margin-left: -40px;
    .el-form-item {
      color: #fff;
    }
    .el-form-item__label {
      color: #fff;
    }
    .login-btn {
      width: 100%;
    }
  }
}
</style>
